const translations = {
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      projects: 'Projects',
      skills: 'Skills',
      contact: 'Contact',
    },
    home: {
      subtitle: 'Fullstack Developer',
      tagline: 'I build websites and apps that just work.',
      ctaProjects: 'See my work',
      ctaContact: 'Get in touch',
    },
    about: {
      title: 'About Me',
      text: 'Software Developer crafting elegant solutions to complex problems. Passionate about building innovative web applications that make a difference.',
      statYears: 'Years Experience',
      statProjects: 'End-to-End Projects',
      statTypo3: 'CI/CD & Automation',
      statFullstack: 'Scalable Web Apps',
      focusTitle: 'Focus Areas',
      focus1: 'Frontend development with React and Vue',
      focus2: 'Backend architectures with Node.js and PHP',
      focus3: 'Deployment, hosting and server administration (Plesk, NGINX)',
      focus4: 'Performance optimization and GDPR-compliant configuration',
      focus5: 'Cloud and DevOps (Azure, CI/CD)',
      focus6: 'E-commerce development with WooCommerce and Shopify',
      focus7: 'Website maintenance, updates and long-term support',
    },
    projects: {
      title: 'Recent Projects',
      modeltool: {
        desc: 'A tool for managing and selecting models with automatic web crawling. Built with React and an Express.js backend.',
        link: 'More Details',
      },
      bms: {
        desc: 'A multi-site solution with multiple websites, developed with Typo3 and WordPress.',
      },
      tagbar: {
        desc: 'A tool for creating dynamic QR codes for Bauhaus.',
        link: 'Visit Website',
      },
      qrtool: {
        desc: 'A serverless QR code generator with dynamic redirect tracking, built with React and Neon DB.',
        link: 'More Details',
      },
      aitool: {
        desc: 'AI-powered job listing analyzer. Paste any job ad and get a breakdown of required skills, responsibilities and positioning tips.',
        link: 'Try it',
      },
      liveDemo: 'Live Demo',
    },
    skills: {
      title: 'Technical Skills',
      frontend: 'Frontend',
      backend: 'Backend',
      tools: 'Tools & Others',
    },
    contact: {
      title: "Let's Connect",
      text: "I'm always open to new opportunities and interesting projects.",
      cv: 'CV',
      email: 'Email Me',
      formName: 'Name',
      formMessage: 'Message',
      formSend: 'Send Message',
      formSent: 'Message sent!',
    },
    aitool: {
      back: '← Back to Overview',
      title: 'Job Fit Analyzer',
      subtitle: 'Paste a job listing and get an instant AI breakdown: required skills, responsibilities, and tips on how to position yourself.',
      inputLabel: 'Job listing',
      placeholder: 'Paste the full job listing here…',
      analyzeBtn: 'Analyze',
      analyzing: 'Analyzing…',
      roleOverview: 'Role Overview',
      requiredSkills: 'Required Skills',
      niceToHave: 'Nice to Have',
      responsibilities: 'Key Responsibilities',
      positioningTips: 'How to Position Yourself',
    },
    lebenslauf: {
      back: '← Back to Overview',
      downloadPdf: 'Download PDF',
      downloadingPdf: 'Creating PDF...',
      downloadImage: 'Download Image',
      downloadingImage: 'Creating image...',
      errorPdf: 'Error creating PDF',
      errorImage: 'Error creating image',
    },
    modeltool: {
      back: '← Back to Overview',
      aboutTitle: 'About the Modeltool',
      aboutText: 'The Modeltool is a web-based platform developed with React and an Express.js backend for managing model bookings. The entire process from casting link to confirmed booking runs through the tool:',
      feature1: 'An agency provides a casting link containing multiple models. This link is entered into the tool and a crawler automatically extracts all model data from the page.',
      feature2: 'The extracted models are displayed directly in the tool and can be saved to the internal database with a single click.',
      feature3: 'From the saved models, a curated selection is compiled and presented to the client who wants to book models. The client then makes their own selection from this shortlist.',
      feature4: 'The client\'s selection is returned to me and I can confirm the final booking with the agency.',
      aboutText2: 'Every model in the system, whether manually created or crawled, has an availability calendar. Available days can be selected and managed directly in the tool, giving a clear overview of each model\'s schedule.',
      offlineNote: 'This project was operated internally and is not publicly accessible.',
      crawlerTitle: 'Crawler Demo (Preview)',
      privacyNote: 'For privacy reasons, no model data is stored in this demo.',
      urlPlaceholder: 'e.g. https://example.com',
      crawlBtn: 'Crawl',
      crawling: 'Crawling…',
      fallbackWarning: '⚠ Live crawl unavailable, sample data is shown.',
      hint: 'Enter a URL and click "Crawl" to display the demo models.',
      openProfile: 'Open Profile →',
      allModelsTitle: 'All crawled models',
      unknown: 'Unknown',
      noProfileUrl: 'No profile URL available for this model.',
      pdfError: 'Error downloading PDF:',
      pdfDownload: 'Download PDF',
      pdfCreating: 'Creating PDF...',
      height: 'Height',
      bust: 'Bust',
      chest: 'Chest',
      waist: 'Waist',
      hips: 'Hips',
      shoes: 'Shoes',
      eyes: 'Eyes',
      hair: 'Hair',
      cup: 'Cup',
      docTitle: 'How does it work?',
      docTechStackTitle: 'Tech Stack',
      docTechStackText1: 'The Modeltool was built with ',
      docTechStackText2: ' as the frontend framework. The backend is built on ',
      docTechStackNode: 'Node.js with Express',
      docTechStackText3: ' and handles all crawling logic as well as PDF generation.',
      docStaticTitle: 'Crawling: Static Pages',
      docStaticText: 'For pages where model data is directly included in the HTML, a simple frontend crawler was sufficient. The HTML is parsed and the relevant model information such as name, measurements and images is extracted directly.',
      docDynamicTitle: 'Crawling: Dynamic Pages',
      docDynamicText1: 'Many casting agencies load their content dynamically via JavaScript. A regular HTTP request does not return usable HTML in these cases. The backend opens a ',
      docDynamicText2: ', receives the URL from the frontend, fully loads the page including JavaScript execution, searches the rendered HTML for a defined schema and sends the extracted data back to the frontend.',
      docDbTitle: 'Database Integration',
      docDbText: 'Crawled models are not just displayed but can be fed directly into the Modeltool database as complete model entries with all available attributes such as measurements, images and profile links. This allows the agency to quickly integrate external casting lists into their own workflow.',
      docPdfTitle: 'PDF Export',
      docPdfText: 'A PDF profile can be generated for each crawled model. The backend fetches the model\'s profile page, extracts images and data, and builds a structured PDF document that can be downloaded directly.',
    },
    bms: {
      pageTitle: 'BMS & Bertelsmann – Web Projects',
      meta: 'Fullstack Developer · MBS Nuremberg · 05/2021 – 03/2026',
      roleTitle: 'Role & Responsibilities',
      roleText: 'As a Fullstack Developer at MBS Nuremberg, I was responsible for operating, maintaining, and further developing eleven TYPO3 instances of the Bertelsmann Marketing Services Group. All websites ran on a shared Plesk server, whose administration was also part of my responsibilities, including SSL certificate management, server monitoring, and deployments.',
      roleLi1: 'Regular TYPO3 core and extension updates to ensure security',
      roleLi2: 'GDPR-compliant configuration of all instances: cookie management, privacy pages, form processing',
      roleLi3: 'SSL certificate management and server monitoring via Plesk',
      roleLi4: 'Development and maintenance of Custom TYPO3 Extensions according to internal requirements',
      roleLi5: 'Content maintenance and editorial support for specialist teams',
      typo3Title: 'TYPO3 Instances',
      typo3Intro: 'Operation and administration of multiple TYPO3 instances on a central Plesk server, including deployment, updates, performance optimization, security measures, and GDPR-compliant configuration.',
      openSite: 'Open Website →',
      adalityTitle: 'Adality',
      adalityIntro: 'Addressable TV advertising platform for data-driven TV targeting. Maintenance, updates, and technical operation as part of the BMS projects.',
      adalityCardDesc: 'Addressable TV Advertising – data-driven TV targeting platform',
      siteDescs: [
        'Address and data marketing solutions',
        'Main website of the BMS Group',
        'Fundraising and donation marketing',
        'Campaign management and dialog marketing',
        'IT services within the BMS Group',
        'Media solutions and production',
        'Printing, fulfillment and logistics',
        'Apprenticeship and career blog',
        'Media replication and distribution',
        'Packaging and film solutions',
        'Print solutions and services',
        'Bertelsmann Printing Group – print solutions for the US market',
      ],
    },
    tagbar: {
      pageTitle: 'Tagbar – QR Code Generator for Bauhaus',
      meta: 'WordPress Plugin Development · Bauhaus AG · 2023',
      descTitle: 'Project Description',
      descText: 'Internal WordPress tool for Bauhaus branches for dynamic QR code creation. Branch employees can generate QR codes for offers and product pages themselves, without involving developers. Developed and deployed as a Custom WordPress Plugin.',
      li1: 'QR code generation directly by branch employees, no development effort required',
      li2: 'Dynamic linking to offers and product pages',
      li3: 'A dynamic QR code tool built with custom plugins',
      liveTitle: 'Live Tool',
      cardDesc: 'QR code generator as a Custom WordPress Plugin, developed and deployed for Bauhaus branches',
      openTool: 'Open Tool →',
    },
  },

  de: {
    nav: {
      home: 'Start',
      about: 'Über mich',
      projects: 'Projekte',
      skills: 'Fähigkeiten',
      contact: 'Kontakt',
    },
    home: {
      subtitle: 'Fullstack-Entwickler',
      tagline: 'Ich baue Webseiten und Apps, die einfach funktionieren.',
      ctaProjects: 'Projekte ansehen',
      ctaContact: 'Kontakt aufnehmen',
    },
    about: {
      title: 'Über mich',
      text: 'Softwareentwickler mit Leidenschaft für elegante Lösungen komplexer Probleme. Fokus auf innovative Webanwendungen, die einen echten Unterschied machen.',
      statYears: 'Jahre Erfahrung',
      statProjects: 'End-to-End Projekte',
      statTypo3: 'CI/CD & Automatisierung',
      statFullstack: 'Scalable Web Apps',
      focusTitle: 'Schwerpunkte',
      focus1: 'Frontend-Entwicklung mit React und Vue',
      focus2: 'Backend-Architekturen mit Node.js und PHP',
      focus3: 'Deployment, Hosting und Server-Administration (Plesk, NGINX)',
      focus4: 'Performance-Optimierung und DSGVO-konforme Konfiguration',
      focus5: 'Cloud und DevOps (Azure, CI/CD)',
      focus6: 'E-Commerce Entwicklung mit WooCommerce und Shopify',
      focus7: 'Websitewartung, Updates und langfristiger Support',
    },
    projects: {
      title: 'Aktuelle Projekte',
      modeltool: {
        desc: 'Ein Tool zur Verwaltung und Auswahl von Models mit automatischem Web Crawling. Entwickelt mit React und einem Express.js Backend.',
        link: 'Mehr Details',
      },
      bms: {
        desc: 'Eine Multisite-Lösung mit mehreren Webseiten, entwickelt mit Typo3 und Wordpress.',
      },
      tagbar: {
        desc: 'Ein Tool zur Erstellung von dynamischen QR-Codes für Bauhaus.',
        link: 'Zur Website',
      },
      qrtool: {
        desc: 'Ein serverloser QR-Code-Generator mit dynamischem Redirect-Tracking, gebaut mit React und Neon DB.',
        link: 'Mehr Details',
      },
      aitool: {
        desc: 'KI-gestützter Stellenanzeigen-Analyzer. Stelle eine Stellenanzeige ein und erhalte eine Aufschlüsselung von Skills, Aufgaben und Positionierungstipps.',
        link: 'Ausprobieren',
      },
      liveDemo: 'Live Demo',
    },
    skills: {
      title: 'Technische Fähigkeiten',
      frontend: 'Frontend',
      backend: 'Backend',
      tools: 'Tools & Sonstiges',
    },
    contact: {
      title: 'Kontakt aufnehmen',
      text: 'Ich bin immer offen für neue Möglichkeiten und interessante Projekte.',
      cv: 'Lebenslauf',
      email: 'E-Mail schreiben',
      formName: 'Name',
      formMessage: 'Nachricht',
      formSend: 'Nachricht senden',
      formSent: 'Nachricht gesendet!',
    },
    aitool: {
      back: '← Zurück zur Übersicht',
      title: 'Job-Fit-Analyzer',
      subtitle: 'Füge eine Stellenanzeige ein und erhalte sofort eine KI-Analyse: geforderte Skills, Aufgaben und Tipps zur optimalen Positionierung.',
      inputLabel: 'Stellenanzeige',
      placeholder: 'Vollständige Stellenanzeige hier einfügen…',
      analyzeBtn: 'Analysieren',
      analyzing: 'Analysiere…',
      roleOverview: 'Rollenübersicht',
      requiredSkills: 'Erforderliche Skills',
      niceToHave: 'Von Vorteil',
      responsibilities: 'Hauptaufgaben',
      positioningTips: 'So positionierst du dich',
    },
    lebenslauf: {
      back: '← Zurück zur Übersicht',
      downloadPdf: 'PDF herunterladen',
      downloadingPdf: 'Erstelle PDF...',
      downloadImage: 'Bild herunterladen',
      downloadingImage: 'Erstelle Bild...',
      errorPdf: 'Fehler beim Erstellen der PDF',
      errorImage: 'Fehler beim Erstellen des Bildes',
    },
    modeltool: {
      back: '← Zurück zur Übersicht',
      aboutTitle: 'Über das Modeltool',
      aboutText: 'Das Modeltool ist eine webbasierte Plattform, entwickelt mit React und einem Express.js Backend, zur Verwaltung von Modelbuchungen. Der gesamte Prozess vom Casting-Link bis zur bestätigten Buchung läuft über das Tool:',
      feature1: 'Eine Agentur stellt einen Casting-Link mit mehreren Models bereit. Dieser Link wird im Tool eingetragen und ein Crawler extrahiert automatisch alle Modelinformationen von der Seite.',
      feature2: 'Die extrahierten Models werden direkt im Tool angezeigt und können per Knopfdruck in der internen Datenbank gespeichert werden.',
      feature3: 'Aus den gespeicherten Models wird eine Auswahl zusammengestellt und dem Kunden präsentiert, der Models buchen möchte. Der Kunde trifft daraus seine eigene Auswahl.',
      feature4: 'Die Auswahl des Kunden geht zurück an mich und ich kann die Buchung der jeweiligen Models bei der Agentur bestätigen.',
      aboutText2: 'Jedes Model im System, ob manuell angelegt oder gecrawlt, besitzt einen Verfügbarkeitskalender. Die verfügbaren Tage können direkt im Tool ausgewählt und verwaltet werden, sodass jederzeit ein klarer Überblick über die Verfügbarkeit der Models besteht.',
      offlineNote: 'Das Projekt wurde intern betrieben und ist nicht öffentlich zugänglich.',
      crawlerTitle: 'Crawler Demo (Preview)',
      privacyNote: 'Aus Datenschutzgründen werden in dieser Demo keine Model-Daten gespeichert.',
      urlPlaceholder: 'z.B. https://example.com',
      crawlBtn: 'Crawl',
      crawling: 'Crawling…',
      fallbackWarning: '⚠ Live-Crawl nicht verfügbar, Beispieldaten werden angezeigt.',
      hint: 'Gib eine URL ein und klicke „Crawl", um die Demo-Models einzublenden.',
      openProfile: 'Profil öffnen →',
      allModelsTitle: 'Alle gecrawlten Models',
      unknown: 'Unbekannt',
      noProfileUrl: 'Keine Profil-URL verfügbar für dieses Model.',
      pdfError: 'Fehler beim Herunterladen der PDF:',
      pdfDownload: 'PDF herunterladen',
      pdfCreating: 'PDF wird erstellt...',
      height: 'Höhe',
      bust: 'Brust',
      chest: 'Brust',
      waist: 'Taille',
      hips: 'Hüfte',
      shoes: 'Schuhgröße',
      eyes: 'Augen',
      hair: 'Haare',
      cup: 'Cup',
      docTitle: 'Wie funktioniert das?',
      docTechStackTitle: 'Tech-Stack',
      docTechStackText1: 'Das Modeltool wurde mit ',
      docTechStackText2: ' als Frontend-Framework entwickelt. Das Backend basiert auf ',
      docTechStackNode: 'Node.js mit Express',
      docTechStackText3: ' und übernimmt die gesamte Crawling-Logik sowie die PDF-Generierung.',
      docStaticTitle: 'Crawling: statische Seiten',
      docStaticText: 'Bei Seiten, deren Model-Daten direkt im HTML enthalten sind, reichte ein einfacher Frontend-Crawler. Das HTML wird geparst und die relevanten Modelinformationen wie Name, Maße und Bilder werden direkt extrahiert.',
      docDynamicTitle: 'Crawling: dynamische Seiten',
      docDynamicText1: 'Viele Casting-Agenturen laden ihre Inhalte dynamisch per JavaScript. Ein normaler HTTP-Request liefert dort kein verwertbares HTML. In diesem Fall öffnet das Backend einen ',
      docDynamicText2: ', empfängt die URL vom Frontend, lädt die Seite vollständig inklusive JavaScript-Ausführung, durchsucht das gerenderte HTML nach einem definierten Schema und schickt die extrahierten Daten zurück ans Frontend.',
      docDbTitle: 'Datenbankintegration',
      docDbText: 'Die gecrawlten Models werden nicht nur angezeigt, sondern können direkt in die Datenbank des Modeltools eingespeist werden als vollwertige Model-Einträge mit allen verfügbaren Attributen wie Maßen, Bildern und Profil-Links. Das ermöglicht es der Agentur, externe Castinglisten schnell in den eigenen Workflow zu übernehmen.',
      docPdfTitle: 'PDF-Export',
      docPdfText: 'Für jedes gecrawlte Model kann ein PDF-Profil generiert werden. Das Backend ruft dafür die Profilseite des Models auf, extrahiert Bilder und Daten und baut daraus ein strukturiertes PDF-Dokument, das direkt heruntergeladen werden kann.',
    },
    bms: {
      pageTitle: 'BMS & Bertelsmann – Webprojekte',
      meta: 'Fullstack-Entwickler · MBS Nürnberg · 05/2021 – 03/2026',
      roleTitle: 'Rolle & Verantwortlichkeiten',
      roleText: 'Als Fullstack-Entwickler bei MBS Nürnberg war ich für Betrieb, Wartung und Weiterentwicklung von elf TYPO3-Instanzen der Bertelsmann Marketing Services Gruppe zuständig. Alle Webseiten liefen auf einem gemeinsamen Plesk-Server, dessen Administration ebenfalls zu meinen Aufgaben gehörte, inklusive SSL-Zertifikatsverwaltung, Servermonitoring und Deployments.',
      roleLi1: 'Regelmäßige TYPO3-Core- und Extension-Updates zur Sicherstellung der Sicherheit',
      roleLi2: 'DSGVO-konforme Konfiguration aller Instanzen: Cookie-Management, Datenschutzseiten, Formularverarbeitung',
      roleLi3: 'SSL-Zertifikatsverwaltung und Server-Monitoring über Plesk',
      roleLi4: 'Entwicklung und Pflege von Custom TYPO3-Extensions nach internen Anforderungen',
      roleLi5: 'Content-Pflege und redaktionelle Unterstützung der Fachteams',
      typo3Title: 'TYPO3 Instanzen',
      typo3Intro: 'Betrieb und Administration mehrerer TYPO3-Instanzen auf einem zentralen Plesk-Server, inklusive Deployment, Updates, Performance-Optimierung, Sicherheitsmaßnahmen und DSGVO-konformer Konfiguration.',
      openSite: 'Website öffnen →',
      adalityTitle: 'Adality',
      adalityIntro: 'Addressable TV Advertising-Plattform für datengetriebenes TV-Targeting. Wartung, Updates und technischer Betrieb im Rahmen der BMS-Projekte.',
      adalityCardDesc: 'Addressable TV Advertising – datengetriebene TV-Targeting-Plattform',
      siteDescs: [
        'Adress- und Datenmarketing-Lösungen',
        'Hauptseite der BMS-Unternehmensgruppe',
        'Fundraising- und Spendenmarketing',
        'Kampagnenmanagement und Dialog-Marketing',
        'IT-Dienstleistungen innerhalb der BMS-Gruppe',
        'Medienlösungen und -produktion',
        'Druckerei, Fulfillment und Logistik',
        'Ausbildungs- und Karriereblog',
        'Medienreplikation und -distribution',
        'Verpackungs- und Folienlösungen',
        'Drucklösungen und -dienstleistungen',
        'Bertelsmann Printing Group – Drucklösungen für den US-Markt',
      ],
    },
    tagbar: {
      pageTitle: 'Tagbar – QR-Code-Generator für Bauhaus',
      meta: 'WordPress Plugin-Entwicklung · Bauhaus AG · 2023',
      descTitle: 'Projektbeschreibung',
      descText: 'Internes WordPress-Tool für Bauhaus-Filialen zur dynamischen QR-Code-Erstellung. Filialmitarbeiter können QR-Codes für Angebote und Produktseiten selbst generieren, ohne Entwickler einzubeziehen. Entwickelt und deployed als Custom WordPress Plugin.',
      li1: 'QR-Code-Generierung direkt durch Filialmitarbeiter, kein Entwicklungsaufwand nötig',
      li2: 'Dynamische Verlinkung auf Angebote und Produktseiten',
      li3: 'Ein dynamisches QR-Code-Tool mit Custom Plugins',
      liveTitle: 'Live-Tool',
      cardDesc: 'QR-Code-Generator als Custom WordPress Plugin, entwickelt und deployed für Bauhaus-Filialen',
      openTool: 'Tool öffnen →',
    },
  },

  tr: {
    nav: {
      home: 'Ana Sayfa',
      about: 'Hakkımda',
      projects: 'Projeler',
      skills: 'Yetenekler',
      contact: 'İletişim',
    },
    home: {
      subtitle: 'Fullstack Geliştirici',
      tagline: 'Düzgün çalışan web siteleri ve uygulamalar geliştiriyorum.',
      ctaProjects: 'Projelerime bak',
      ctaContact: 'İletişime geç',
    },
    about: {
      title: 'Hakkımda',
      text: 'Karmaşık sorunlara zarif çözümler üreten yazılım geliştirici. Fark yaratan yenilikçi web uygulamaları geliştirme konusunda tutkulum.',
      statYears: 'Yıl Deneyim',
      statProjects: 'Uçtan Uca Proje',
      statTypo3: 'CI/CD & Otomasyon',
      statFullstack: 'Ölçeklenebilir Web Uygulaması',
      focusTitle: 'Uzmanlık Alanları',
      focus1: 'React ve Vue ile frontend geliştirme',
      focus2: 'Node.js ve PHP ile backend mimarileri',
      focus3: 'Deployment, barındırma ve sunucu yönetimi (Plesk, NGINX)',
      focus4: 'Performans optimizasyonu ve KVKK uyumlu yapılandırma',
      focus5: 'Bulut ve DevOps (Azure, CI/CD)',
      focus6: 'WooCommerce ve Shopify ile e-ticaret geliştirme',
      focus7: 'Web sitesi bakımı, güncellemeler ve uzun vadeli destek',
    },
    projects: {
      title: 'Son Projeler',
      modeltool: {
        desc: 'Otomatik web tarama ile model yönetimi ve seçimi yapan bir araç. React ve Express.js backend ile geliştirildi.',
        link: 'Daha Fazla',
      },
      bms: {
        desc: 'Typo3 ve WordPress ile geliştirilen çok siteli bir web çözümü.',
      },
      tagbar: {
        desc: 'Bauhaus için dinamik QR kodları oluşturmaya yarayan bir araç.',
        link: 'Siteye Git',
      },
      qrtool: {
        desc: 'React ve Neon DB ile geliştirilmiş, dinamik yönlendirme takibi olan sunucusuz bir QR kod üreteci.',
        link: 'Daha Fazla',
      },
      aitool: {
        desc: 'Yapay zeka destekli iş ilanı analizörü. Bir ilan yapıştır, gerekli beceriler, sorumluluklar ve konumlanma ipuçlarını anında al.',
        link: 'Dene',
      },
      liveDemo: 'Canlı Demo',
    },
    skills: {
      title: 'Teknik Beceriler',
      frontend: 'Frontend',
      backend: 'Backend',
      tools: 'Araçlar & Diğer',
    },
    contact: {
      title: 'İletişime Geç',
      text: 'Yeni fırsatlara ve ilginç projelere her zaman açığım.',
      cv: 'CV',
      email: 'E-posta Gönder',
      formName: 'Ad',
      formMessage: 'Mesaj',
      formSend: 'Mesaj Gönder',
      formSent: 'Mesaj gönderildi!',
    },
    aitool: {
      back: '← Genel Bakışa Dön',
      title: 'İş İlanı Analizörü',
      subtitle: 'Bir iş ilanı yapıştır, anında yapay zeka analizi al: gerekli beceriler, sorumluluklar ve nasıl konumlanacağına dair ipuçları.',
      inputLabel: 'İş ilanı',
      placeholder: 'İş ilanının tamamını buraya yapıştır…',
      analyzeBtn: 'Analiz Et',
      analyzing: 'Analiz ediliyor…',
      roleOverview: 'Rol Özeti',
      requiredSkills: 'Gerekli Beceriler',
      niceToHave: 'Tercih Sebebi',
      responsibilities: 'Temel Sorumluluklar',
      positioningTips: 'Nasıl Konumlanmalısın',
    },
    lebenslauf: {
      back: '← Genel Bakışa Dön',
      downloadPdf: 'PDF İndir',
      downloadingPdf: 'PDF oluşturuluyor...',
      downloadImage: 'Görüntü İndir',
      downloadingImage: 'Görüntü oluşturuluyor...',
      errorPdf: 'PDF oluşturulurken hata oluştu',
      errorImage: 'Görüntü oluşturulurken hata oluştu',
    },
    modeltool: {
      back: '← Genel Bakışa Dön',
      aboutTitle: 'Model Aracı Hakkında',
      aboutText: 'Modeltool, React ve Express.js backend ile geliştirilmiş, model rezervasyonlarını yönetmek için web tabanlı bir platformdur. Casting bağlantısından onaylı rezervasyona kadar tüm süreç araç üzerinden yürütülür:',
      feature1: 'Bir ajans birden fazla model içeren bir casting bağlantısı sağlar. Bu bağlantı araca girilir ve bir crawler sayfadaki tüm model bilgilerini otomatik olarak çıkarır.',
      feature2: 'Çıkarılan modeller araçta doğrudan görüntülenir ve tek bir tıklamayla dahili veritabanına kaydedilebilir.',
      feature3: 'Kaydedilen modellerden bir seçki oluşturularak model kiralamak isteyen müşteriye sunulur. Müşteri bu kısa listeden kendi seçimini yapar.',
      feature4: "Müşterinin seçimi bana iletilir ve ilgili modellerin ajans üzerinden rezervasyonunu onaylayabilirim.",
      aboutText2: 'Sistemdeki her model, ister manuel eklenen ister crawler ile elde edilen, bir uygunluk takvimine sahiptir. Uygun günler doğrudan araç üzerinden seçilip yönetilebilir; böylece her modelin programı her zaman net bir şekilde görülebilir.',
      offlineNote: 'Bu proje dahili olarak işletilmiş olup kamuya açık değildir.',
      crawlerTitle: 'Tarayıcı Demosu (Önizleme)',
      privacyNote: 'Gizlilik nedeniyle bu demoda model verisi saklanmamaktadır.',
      urlPlaceholder: 'örn. https://example.com',
      crawlBtn: 'Tara',
      crawling: 'Taranıyor…',
      fallbackWarning: '⚠ Canlı tarama mevcut değil, örnek veriler gösteriliyor.',
      hint: 'Demo modelleri görüntülemek için bir URL girin ve "Tara"ya tıklayın.',
      openProfile: 'Profili Aç →',
      allModelsTitle: 'Taranan tüm modeller',
      unknown: 'Bilinmiyor',
      noProfileUrl: "Bu model için profil URL'si mevcut değil.",
      pdfError: 'PDF indirme hatası:',
      pdfDownload: 'PDF İndir',
      pdfCreating: 'PDF oluşturuluyor...',
      height: 'Boy',
      bust: 'Göğüs',
      chest: 'Göğüs',
      waist: 'Bel',
      hips: 'Kalça',
      shoes: 'Ayakkabı',
      eyes: 'Göz',
      hair: 'Saç',
      cup: 'Kup',
    },
    bms: {
      pageTitle: 'BMS & Bertelsmann – Web Projeleri',
      meta: 'Fullstack Geliştirici · MBS Nürnberg · 05/2021 – 03/2026',
      roleTitle: 'Rol & Sorumluluklar',
      roleText: "MBS Nürnberg'de Fullstack Geliştirici olarak Bertelsmann Marketing Services Grubu'nun on bir TYPO3 örneğinin işletilmesi, bakımı ve geliştirilmesinden sorumluydum. Tüm web siteleri ortak bir Plesk sunucusu üzerinde çalışıyordu; SSL sertifika yönetimi, sunucu izleme ve deployment dahil olmak üzere bu sunucunun yönetimi de görevlerim arasındaydı.",
      roleLi1: 'Güvenliği sağlamak için düzenli TYPO3 çekirdek ve uzantı güncellemeleri',
      roleLi2: 'Tüm örneklerin KVKK uyumlu yapılandırması: çerez yönetimi, gizlilik sayfaları, form işleme',
      roleLi3: 'Plesk üzerinden SSL sertifika yönetimi ve sunucu izleme',
      roleLi4: 'Dahili gereksinimlere göre Özel TYPO3 Uzantıları geliştirme ve bakım',
      roleLi5: 'İçerik bakımı ve uzman ekiplere editoryal destek',
      typo3Title: 'TYPO3 Örnekleri',
      typo3Intro: 'Merkezi bir Plesk sunucusunda birden fazla TYPO3 örneğinin işletimi ve yönetimi; deployment, güncellemeler, performans optimizasyonu, güvenlik önlemleri ve KVKK uyumlu yapılandırma dahil.',
      openSite: 'Siteyi Aç →',
      adalityTitle: 'Adality',
      adalityIntro: 'Veri odaklı TV hedeflemesi için adreslenebilir TV reklam platformu. BMS projeleri kapsamında bakım, güncellemeler ve teknik işletim.',
      adalityCardDesc: 'Adreslenebilir TV Reklamcılığı – veri odaklı TV hedefleme platformu',
      siteDescs: [
        'Adres ve veri pazarlama çözümleri',
        "BMS Grubu'nun ana web sitesi",
        'Bağış toplama ve bağış pazarlaması',
        'Kampanya yönetimi ve diyalog pazarlaması',
        'BMS Grubu bünyesinde IT hizmetleri',
        'Medya çözümleri ve prodüksiyon',
        'Baskı, fulfillment ve lojistik',
        'Çıraklık ve kariyer blogu',
        'Medya replikasyonu ve dağıtımı',
        'Ambalaj ve film çözümleri',
        'Baskı çözümleri ve hizmetleri',
        'Bertelsmann Printing Group – ABD pazarı için baskı çözümleri',
      ],
    },
    tagbar: {
      pageTitle: 'Tagbar – Bauhaus için QR Kod Üreteci',
      meta: 'WordPress Plugin Geliştirme · Bauhaus AG · 2023',
      descTitle: 'Proje Açıklaması',
      descText: 'Bauhaus şubeleri için dinamik QR kod oluşturma amacıyla geliştirilmiş dahili bir WordPress aracı. Şube çalışanları, geliştiricilere gerek kalmadan teklifler ve ürün sayfaları için kendi QR kodlarını oluşturabilir. Özel WordPress Plugin olarak geliştirilip deploy edilmiştir.',
      li1: 'Şube çalışanları tarafından doğrudan QR kod oluşturma, geliştirme çabası gerekmez',
      li2: 'Teklifler ve ürün sayfalarına dinamik bağlantı',
      li3: 'Özel eklentilerle geliştirilmiş dinamik bir QR kod aracı',
      liveTitle: 'Canlı Araç',
      cardDesc: 'Özel WordPress Plugin olarak geliştirilen ve Bauhaus şubeleri için deploy edilen QR kod üreteci',
      openTool: 'Aracı Aç →',
    },
  },
};

export default translations;
